export default __webpack_public_path__ + "static/media/ic_innovate.89e23c01.svg";